import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const EachWayDetailsWrapper = withConfig(theme => styled('div', { label: 'EachWayDetailsWrapper' })`
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    gap: 4px;
    justify-content: flex-end;
    line-height: 1.2;
    margin: 0;
    padding: 8px;
    white-space: nowrap;
`);
